module.exports = __webpack_public_path__ + "img/tempuracaliforniacutted.b2a97b1a.png";